import React, {useEffect, useState} from 'react'
import axios from "axios";
import {Button, Col, Container, Form, InputGroup, Row, Table, Card} from "react-bootstrap";
import './ReporteMovements.css';
import {Search} from "@carbon/icons-react";

const ReporteMovements = () => {

    const [movementReport, setMovementReport] = useState([]);
    const [totalAmountEgress, setTotalAmountEgress] = useState(null);
    const [totalAmountIncome, setTotalAmountIncome] = useState(null);
    const [totalDifferenceAmountIncomeAndEgress, setTotalDifferenceAmountIncomeAndEgress] = useState(null);
    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [isDateFromInvalid, setIsDateFromInvalid] = useState(false);
    const [isDateToInvalid, setIsDateToInvalid] = useState(false);

    const [isExporting, setIsExporting] = useState(false);

    const getConfig = () => {
        return {
            withCredentials: true,
            params: {
                fromDate: dateFrom,
                toDate: dateTo
            }
        }
    }

    useEffect(() => {
        document.title = 'QReate - Reporte de Movimientos';
    });

    const getAllMovements = () => {
        if(!dateFrom && !dateTo) {
            setIsDateFromInvalid(true);
            setIsDateToInvalid(true);
        } else {
            axios.get(process.env.REACT_APP_API_REPORTE_MOVEMEMENT_ROUTE, getConfig())
                .then((response) => {
                    setMovementReport(response.data.reportIncomeAndEgressDetailsDTOS);
                    setTotalAmountIncome(response.data.totalAmountIncome);
                    setTotalAmountEgress(response.data.totalAmountEgress);
                    setTotalDifferenceAmountIncomeAndEgress(response.data.totalDifferenceAmountIncomeAndEgress);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === 'dateFrom') {
            setDateFrom(value);
            setIsDateFromInvalid(false);
        } else if (name === 'dateTo') {
            setDateTo(value);
            setIsDateToInvalid(false);
        }
    };

    function formatPrice(price) {
        if (!price) return ''; // Manejar caso de valor vacío
        const parts = price.toString().split('.'); // Separar parte entera de la decimal
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Agregar separador de miles
        return parts.join(','); // Unir las partes con coma como separador decimal
    }

    const exportData = () => {
        setIsExporting(true);

        axios.get(process.env.REACT_APP_API_REPORTE_MOVEMEMENT_EXPORT_ROUTE, {
            ...getConfig(),
            responseType: 'blob'
        })
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Reporte_Movimientos.xlsx');
                document.body.appendChild(link);
                link.click();

                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);
            })
            .catch((error) => {
                console.error('Error downloading file:', error);
                // Mostrar mensaje de error al usuario
            })
            .finally(() => {
                setIsExporting(false);
            });
    };

// En el JSX
    <Button
        onClick={exportData}
        disabled={isExporting}
    >
        {isExporting ? 'Exportando...' : 'Exportar'}
    </Button>

    return (
        <div className="reporteCategoriasContainer">
            <Container className="mt-3 mb-3">
                <Row>
                    <Col>
                        <h1 className="titleReporteCategorias">Reporte de movimientos (Pedidos, Ingresos y Egresos)</h1>
                    </Col>
                </Row>
            </Container>
            <Container>
                <Row>
                    <Col xs={5}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>Fecha Desde</InputGroup.Text>
                            <Form.Control
                                aria-label="dateFrom"
                                type="date"
                                name="dateFrom"
                                value={dateFrom}
                                onChange={handleDateChange}
                                isInvalid={isDateFromInvalid}
                            />
                        </InputGroup>
                    </Col>
                    <Col xs={5}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>Fecha Hasta</InputGroup.Text>
                            <Form.Control
                                aria-label="dateTo"
                                type="date"
                                name="dateTo"
                                value={dateTo}
                                onChange={handleDateChange}
                                isInvalid={isDateToInvalid}
                            />
                        </InputGroup>
                    </Col>
                    <Col xs={1}>
                        <Button className="me-1" variant="primary" onClick={() => getAllMovements()}>
                            <Search/>
                        </Button>
                    </Col>
                </Row>
            </Container>
            {totalAmountEgress !== null && totalAmountIncome !== null && totalDifferenceAmountIncomeAndEgress !== null && (
                <Row className="m-4">
                    <Col md={4}>
                        <Card bg="danger" text="white" className="text-center shadow-lg">
                            <Card.Body>
                                <Card.Title>Total Egresos</Card.Title>
                                <Card.Text style={{ fontSize: "2rem" }}>
                                    ${totalAmountEgress}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card bg="success" text="white" className="text-center shadow-lg">
                            <Card.Body>
                                <Card.Title>Total Ingresos</Card.Title>
                                <Card.Text style={{ fontSize: "2rem" }}>
                                    ${totalAmountIncome}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card bg="primary" text="white" className="text-center shadow-lg">
                            <Card.Body>
                                <Card.Title>TOTAL Diferencia</Card.Title>
                                <Card.Text style={{ fontSize: "2rem" }}>
                                    ${totalDifferenceAmountIncomeAndEgress}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}
            <Container fluid>
                <Row>
                    <Col>
                        <Table responsive className="table-striped">
                            <thead>
                            <tr>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Descripcion Movimiento / Dueño de pedido
                                </th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Tipo
                                </th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Monto
                                </th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Fecha
                                </th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Forma de pago (Movimiento)
                                </th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Numero de pedido (Pedido)
                                </th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Observacion (Movimiento)
                                </th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Tipo de pedido (Pedido)
                                </th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Sucursal
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {movementReport.length === 0 ? (
                                <tr>
                                    <td colSpan="9" className="text-center">Por favor ingrese un filtro</td>
                                </tr>
                            ) : (
                                movementReport.map((movement) => (
                                    <tr
                                        key={movement.id}
                                        className={movement.type === "EGRESS" ? "egreso" : "ingreso"}
                                    >
                                        <td>{movement.description}</td>
                                        <td className={movement.type === "EGRESS" ? "egreso" : "ingreso"}>{movement.type === "EGRESS" ? "Egreso" : "Ingreso"}</td>
                                        <td>$ {movement.amount}</td>
                                        <td>{movement.date}</td>
                                        <td>{movement.payMethodEgress}</td>
                                        <td>{movement.orderNumberIncome}</td>
                                        <td>{movement.observationEgress}</td>
                                        <td>{movement.orderTypeIncome}</td>
                                        <td>{movement.shopBranchName}</td>
                                    </tr>
                                ))
                            )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
            {totalAmountEgress != null && totalAmountIncome != null && totalDifferenceAmountIncomeAndEgress != null && <Button disabled={isExporting} style={{marginTop: '1%', marginLeft: '1%'}} onClick={exportData}>Exportar</Button> }

        </div>
    )

}

export default ReporteMovements;